import { render } from "./createsalesreturn.vue?vue&type=template&id=1ad66902&scoped=true"
import script from "./createsalesreturn.vue?vue&type=script&lang=js"
export * from "./createsalesreturn.vue?vue&type=script&lang=js"

import "./createsalesreturn.vue?vue&type=style&index=0&id=1ad66902&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad66902"]])

export default __exports__